import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSearchInput from '../../shared/CBSearchInput';
import {
  createWorkshop as _createWorkshop,
  updateWorkshop as _updateWorkshop,
  fetchWorkshops as _fetchWorkshops,
  setWorkshopDisabled as _setWorkshopDisabled,
} from '../../../actions/workshopActions';
import CBHeaderTextWithHelp from '../../shared/CBHeaderTextWithHelp';
import WorkshopListItem from './WorkshopListItem';
import WorkshopForm from './WorkshopForm';
import CBButtonLarge from '../../shared/CBButtonLarge';
import CBSelect from '../../shared/CBSelect';
import CBButtonWithIconSmall from '../../shared/CBButtonWithIconSmall';
import { API_URL } from '../../../config';

const STATUS_ALL = 'all';

class StaffSettingsWorkshops extends React.Component {
  state = {
    selectedWorkshop: null,
    status: STATUS_ALL,
    search: '',
  };

  componentDidMount = () => {
  };

  componentWillReceiveProps(nextProps) {
    const { selectedWorkshop } = this.state;

    // Keep the open form in sync after e.g. disabling the workshop, which updates the
    // object in the store but not this component's local copy.
    if (nextProps.workshops && selectedWorkshop && selectedWorkshop.id) {
      const workshop = nextProps.workshops.find(ws => ws.id === selectedWorkshop.id);
      if (workshop && workshop !== selectedWorkshop) {
        this.setState({ selectedWorkshop: workshop });
      }
    }
  }

  selectWorkshop = (id) => {
    const { workshops } = this.props;
    const workshop = workshops.find((ws) => {
      return id == ws.id
    });
    this.setState({ selectedWorkshop: Object.assign({}, workshop) });
  };

  getFetchParams = (overrides) => {
    const { search, status } = this.state;
    const params = Object.assign({ search, status }, overrides);

    if (!params.search) {
      delete params.search;
    }
    if (!params.status || params.status === STATUS_ALL) {
      delete params.status;
    }

    return params;
  };

  changeSearchTerms = (value) => {
    this.setState({ search: value });
  };

  changeStatus = (event) => {
    const status = event.target.value;
    const { fetchWorkshops } = this.props;

    this.setState({ status });

    // The workshop list is normally search driven, but a status filter on its own is a
    // meaningful query too - otherwise picking "disabled" would just show an empty list.
    fetchWorkshops(this.getFetchParams({ status }));
  };

  setWorkshopDisabled = (workshopId, disabled, reason) => {
    const { setWorkshopDisabled } = this.props;
    setWorkshopDisabled(workshopId, disabled, reason);
  };

  exportCsv = () => {
    const params = new URLSearchParams();
    const fetchParams = this.getFetchParams();

    Object.keys(fetchParams).forEach((key) => {
      params.set(key, fetchParams[key]);
    });

    const query = params.toString();
    window.open(
      `${API_URL}/uiapi/1/workshop/export_csv/${query ? `?${query}` : ''}`,
      '_blank'
    );
  };

  createNewWorkshop = () => {
    const newWorkshop = {
      business_id: '',
      name: '',
      organization_name: '',
      street_address: '',
      zip_code: '',
      city: '',
      phone_number: '',
      contact_name: '',
      contact_phone_number: '',
    }

    this.setState({ selectedWorkshop: Object.assign({}, newWorkshop) });
  }

  render() {
    const {
      workshops, t, createWorkshop, updateWorkshop, workshopRequest
    } = this.props;
    const { selectedWorkshop, status } = this.state;

    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={getStyle(screenSize, styles, 'container')}>
            <div style={getStyle(screenSize, styles, 'editWorkshopsContainer')}>
              <div style={getStyle(screenSize, styles, 'addWorkshopContainer')}>
                <CBButtonLarge text={t('addWorkshopButton')} onClick={this.createNewWorkshop} />
              </div>
              <div style={getStyle(screenSize, styles, 'workshopFormContainer')}>
                <CBHeaderTextWithHelp text={t('staffWorkshopsHeading')} />
                {
                  selectedWorkshop && (
                    <WorkshopForm
                      workshop={selectedWorkshop}
                      workshopRequest={workshopRequest}
                      createWorkshop={createWorkshop}
                      updateWorkshop={updateWorkshop}
                      setWorkshopDisabled={this.setWorkshopDisabled}
                    />
                  )
                }
              </div>
            </div>
            <div style={getStyle(screenSize, styles, 'searchWorkshopContainer')}>
              <CBButtonLarge
                style={getStyle(screenSize, styles, 'largeButton')}
                text={t('Footer:logoutButton')}
                href='/accounts/logout/'
              />
              <CBHeaderTextWithHelp text={t('workshopsSearchHeading')} />
              <div style={getStyle(screenSize, styles, 'searchContainer')}>
                <CBSearchInput
                  containerStyle={{ marginLeft: 0 }}
                  type='workshop'
                  changeSearchTerms={this.changeSearchTerms}
                  extraParams={status !== STATUS_ALL ? { status } : {}}
                />
              </div>
              <div style={getStyle(screenSize, styles, 'filterContainer')}>
                <div style={getStyle(screenSize, styles, 'statusSelectContainer')}>
                  <CBSelect value={status} onChange={this.changeStatus}>
                    <option value='all'>{t('filterStatusAll')}</option>
                    <option value='active'>{t('filterStatusActive')}</option>
                    <option value='disabled'>{t('filterStatusDisabled')}</option>
                  </CBSelect>
                </div>
                <CBButtonWithIconSmall
                  icon='/img/icon_download.svg'
                  text={t('exportCsvButton')}
                  onClick={this.exportCsv}
                />
              </div>
              <div style={getStyle(screenSize, styles, 'resultContainer')}>
                {workshops
                  .map(workshop => (
                    <WorkshopListItem
                      key={workshop.id}
                      buttonAction={this.selectWorkshop}
                      label={workshop.name}
                      editMode={true}
                      id={workshop.id}
                      isFavourite={false}
                      isDisabled={workshop.is_disabled}
                      value={`${workshop.street_address}, ${workshop.zip_code} ${workshop.city}`}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      paddingBottom: 50,
    },
    addWorkshopContainer: {
      marginBottom: 40,
    },
    editWorkshopsContainer: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 40,
      width: '50%',
      borderRight: '1px solid rgba(255, 255, 255, 0.4)',
      minHeight: 500,
    },
    searchWorkshopContainer: {
      width: '50%',
      padding: 20,
      paddingLeft: 20,
      paddingRight: 20,
    },
    searchContainer: {
      marginBottom: 16,
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 16,
    },
    statusSelectContainer: {
      width: 220,
    },
    largeButton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 50,
      border: '2px solid #00f600',
      cursor: 'pointer',
      borderRadius: 50,
      ':hover': {
        backgroundColor: '#00f600',
      },
      marginTop: 20,
      marginBottom: 45,
    },
  },
  medium: {
    container: {
      paddingBottom: 25,
    },
    addWorkshopContainer: {
      marginBottom: 20,
    },
    editWorkshopsContainer: {
      paddingLeft: 0,
      paddingRight: 15,
      paddingTop: 15,
    },
    searchWorkshopContainer: {
      padding: 15,
      paddingLeft: 15,
      paddingRight: 0,
    },
    largeButton: {
      width: 280,
      height: 50,
      marginTop: 'unset',
      marginBottom: 25,
    },
  },
  small: {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    editWorkshopsContainer: {
      paddingLeft: 0,
      paddingRight: 0,
      width: '100%',
      borderRight: 0,
      marginBottom: 20,
      minHeight: 0,
    },
    searchWorkshopContainer: {
      width: '100%',
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: 20,
    },
    largeButton: {
      width: 240,
      height: 50,
    },
  },
};

function mapStateToProps(state) {
  return {
    workshops: state.workshop.workshops,
    workshopRequest: state.workshop,
  };
}

export default connect(
  mapStateToProps,
  {
    createWorkshop: _createWorkshop,
    updateWorkshop: _updateWorkshop,
    fetchWorkshops: _fetchWorkshops,
    setWorkshopDisabled: _setWorkshopDisabled,
  },
)(translate('SettingsView')(StaffSettingsWorkshops));
